import { render, staticRenderFns } from "./ModalStepDocumentsList.vue?vue&type=template&id=5e2b9a13&scoped=true&"
import script from "./ModalStepDocumentsList.vue?vue&type=script&lang=js&"
export * from "./ModalStepDocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./ModalStepDocumentsList.vue?vue&type=style&index=0&id=5e2b9a13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b9a13",
  null
  
)

export default component.exports